/* Jquery match height */
$('.footer-list').matchHeight();
$('.card').matchHeight();
$('.gallery-image-description').matchHeight();
$('.sponsor').matchHeight();
